import { Avatar, Box, Text } from 'grommet'
import { Down } from 'grommet-icons'
import { AddCircle } from '../../../assets/svgs'
import { DetailNote, src } from '../../../constants'
import { Button } from '../Button'
import { DropdownBtn } from '../DropdownBtn'

export const Note = () => {
  return (
    <Box gap={'16px'} pad={{ horizontal: 'medium', top: 'medium' }}>
      <Box direction="row" justify="between" pad={{ horizontal: '12px' }}>
        <Box>
          <DropdownBtn
            dropdownIcon={<Down size="small" />}
            dropdownLabel="Newest"
            margin="0"
            options={[
              {
                handleClick: () => console.log('Active clicked'),
                label: 'Older',
                reverse: true
              },
              {
                handleClick: () => console.log('Inactive clicked'),
                label: 'Newest',
                reverse: true
              }
            ]}
            pad={{ horizontal: '4px', vertical: '5px' }}
            reverse
            secondary
            style={{ border: '0', fontSize: '16px', fontWeight: '500' }}
          />
        </Box>
        <Box>
          <Button icon={<AddCircle style={{ marginRight: '-8px' }} />} label="Add Note" onClick={() => {}} />
        </Box>
      </Box>
      <Box className="staff-container " pad={{ horizontal: '14px' }} style={{ height: '100%' }}>
        {[...Array(3)]?.map((_, index) => (
          <Box key={index} margin={{ top: '12px' }} pad={{ bottom: '18px' }}>
            <Box align="center" direction="row" gap="8px" margin={{ bottom: '12px' }}>
              <Avatar size="20px" src={src} />
              <Text size="14px">{DetailNote.name}</Text>
              <Box background={'#D9D9D9'} height={'4px'} round={'full'} width={'4px'} />
              <Text color={'#4D4D4D'} size="12px">
                {DetailNote.date}
              </Text>
            </Box>
            <Box pad={{ right: '40px' }}>
              <Text color={'#666'} size="14px">
                {DetailNote.note}
              </Text>
            </Box>
          </Box>
        ))}
        {/* <Box align="center" alignSelf="center" justify="center" margin={{ top: '60px' }} width={'100%'}>
            <Box>
              <EmptyNote />
              <Text margin={{ top: '16px' }} size="14px">
                No notes entered
              </Text>
            </Box>
          </Box> */}
      </Box>
    </Box>
  )
}
